var map = {
	"./Dutch.png": "IPaY",
	"./English.png": "sQms",
	"./German.png": "vZKO",
	"./france.png": "V+SI",
	"./italy.png": "YQ3Z",
	"./spain.png": "N365"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1CGP";